<template>
  <div class="cloud-SafeStep">
    <div class="cloud-SafeStep-l">
      <div class="cloud-SafeStep-title" style="width: 100%; height: 36.5vh">
        <div class="cloud-SafeStep-title-title">
          <img src="@/assets/images/groupTitle.png" alt="" />
          <p>洞内施工情况</p>

          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '10%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 88%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-SafeStep-title-content"
          style="width: 100%; height: 33vh; overflow: hidden"
        >
          <ul class="cloud-SafeStep-title-content-ul">
            <li style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)">
              <div>
                <div id="main_Personnel1" class="chart-container"></div>
              </div>
              <div>
                <p>15%</p>
                <p>掌子面施工</p>
              </div>
              <div>
                <p>
                  实际进度：<span>{{ fromData.excavationTotalCompleted }}</span
                  >m
                </p>
                <p>
                  工程总长：<span>{{ fromData.excavationQuantity }}</span
                  >m
                </p>
              </div>
            </li>
            <li style="border-bottom: 1px solid rgba(255, 255, 255, 0.12)">
              <div>
                <div id="main_Personnel2" class="chart-container"></div>
              </div>
              <div>
                <p>15%</p>
                <p>仰拱施工</p>
              </div>
              <div>
                <p>
                  实际进度：<span>{{ fromData.invertTotalCompleted }}</span
                  >m
                </p>
                <p>
                  工程总长：<span>{{ fromData.invertQuantity }}</span
                  >m
                </p>
              </div>
            </li>
            <li>
              <div>
                <div id="main_Personnel3" class="chart-container"></div>
              </div>
              <div>
                <p>15%</p>
                <p>二衬施工</p>
              </div>
              <div>
                <p>
                  实际进度：<span>{{ fromData.liningTotalCompleted }}</span
                  >m
                </p>
                <p>
                  工程总长：<span>{{ fromData.liningQuantity }}</span
                  >m
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div
        class="cloud-SafeStep-title"
        style="width: 100%; height: 22.5vh; margin-top: 2vh"
      >
        <div class="cloud-SafeStep-title-title">
          <img src="@/assets/images/groupTitle.png" alt="" />
          <p style="width: 12vw; float: left">围岩量测</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '10%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 88%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-SafeStep-title-content"
          style="width: 100%; height: 20vh; overflow: hidden"
        >
          <div
            class="cloud-SafeStep-title-content-tables"
            style="height: 4.5vh"
          >
            <p style="color: #fff; width: 28%">断面(围岩级别)/测点线</p>
            <p style="color: #fff">变形速率 (mm/d)</p>
            <p style="color: #fff">累计变形 量(mm)</p>
            <p style="color: #fff; width: 16%">报警 级别</p>
            <p style="color: #fff; width: 16%">检测 时间</p>
          </div>
          <div
            style="
              width: 100%;
              height: 14vh;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
            "
          >
            <div
              class="cloud-SafeStep-title-content-tables"
              v-for="(item, index) in 0"
              :key="index"
            >
              <p style="width: 28%">龙烟隧道右边</p>
              <p>二氧化碳</p>
              <p>二衬台车</p>
              <p style="width: 16%">10.89</p>
              <p style="width: 16%">12:24</p>
            </div>
          </div>
        </div>
      </div>

      <div
        class="cloud-SafeStep-title"
        style="width: 100%; height: 21.5vh; margin-top: 2vh"
      >
        <div class="cloud-SafeStep-title-title">
          <img src="@/assets/images/groupTitle.png" alt="" />
          <p>超前地质预报</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '10%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 88%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-SafeStep-title-content"
          style="width: 100%; height: 18vh; overflow: hidden"
        >
          <div class="cloud-SafeStep-title-content-tables">
            <p style="color: #fff">预报类型</p>
            <p style="color: #fff">开始里程</p>
            <p style="color: #fff">结束里程</p>
            <p style="color: #fff">探测长度</p>
            <p style="color: #fff">风险管理</p>
          </div>
          <div
            style="
              width: 100%;
              height: 14vh;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
            "
          >
            <div
              class="cloud-SafeStep-title-content-tables"
              v-for="(item, index) in 0"
              :key="index"
            >
              <p>龙烟隧道右边</p>
              <p>二氧化碳</p>
              <p>二衬台车</p>
              <p>10.89</p>
              <p>12:24</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cloud-SafeStep-r">
      <div class="cloud-SafeStep-title" style="width: 100%; height: 49.5vh">
        <div
          class="cloud-SafeStep-title-content"
          style="width: 100%; height: 48vh; overflow: hidden"
        >
          <iframe
            style="width: 100%; height: 50vh"
            :src="srcPath"
            frameborder="0"
          ></iframe>
        </div>
      </div>

      <div
        class="cloud-SafeStep-title"
        style="width: 100%; height: 32.7vh; margin-top: 2vh"
      >
        <div class="cloud-SafeStep-title-title">
          <img src="@/assets/images/groupTitlec.png" alt="" />
          <p>安全步距列表</p>
          <dv-decoration-3
            class="decoration-container"
            :style="{ width: '3%', height: '30px' }"
            style="position: absolute; top: 1px; margin-left: 96%"
          >
            <!-- 插槽中添加多个小方块 -->
            <div slot="content" class="squares-container">
              <div class="square s1"></div>
              <div class="square s2"></div>
              <div class="square s3"></div>
              <div class="square s4"></div>
              <div class="square s5"></div>
              <div class="square s6"></div>
            </div>
          </dv-decoration-3>
        </div>
        <div
          class="cloud-SafeStep-title-content"
          style="width: 100%; height: 26vh; overflow: hidden"
        >
          <div class="cloud-SafeStep-title-content-table">
            <p style="color: #fff">序号</p>
            <p style="color: #fff">日期</p>
            <p style="color: #fff">围岩等级</p>
            <p style="color: #fff">掌子面桩号</p>
            <p style="color: #fff">掌子面累尺</p>
            <p style="color: #fff">仰拱桩号</p>
            <p style="color: #fff">仰拱累尺</p>
            <p style="color: #fff">距离掌子面</p>
            <p style="color: #fff">是否合规</p>
            <p style="color: #fff">二村桩号</p>
            <p style="color: #fff">二村累尺</p>
            <p style="color: #fff">距离掌子面</p>
            <p style="color: #fff">是否合规</p>
          </div>
          <div
            style="
              width: 100%;
              height: 21vh;
              overflow-y: auto;
              scrollbar-width: thin;
              scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
            "
          >
            <div
              class="cloud-SafeStep-title-content-table"
              v-for="(item, index) in StepDataData"
              :key="index"
            >
              <p>{{ index }}</p>
              <p>{{ item.stepTime }}</p>
              <p>{{ item.stepType === "" ? "Ⅲ" : "Ⅳ" }}</p>
              <p>{{ fromData.pileNoMark }}</p>
              <p>{{ item.erChenData }}</p>
              <p>-</p>
              <p>{{ item.fangShuiData }}</p>
              <p>{{ fromData.invertTotalCompleted }}</p>
              <p>合规</p>
              <p>-</p>
              <p>{{ item.stepErchenData }}</p>
              <p>{{ fromData.liningTotalCompleted }}</p>
              <p>合规</p>
            </div>
          </div>
        </div>
        <div>
          <!-- <p
            style="
              width: 20%;
              height: 3.5vh;
              line-height: 3.5vh;
              float: left;
              margin-left: 1vw;
              margin: 0px;
              padding: 0px;
              color: rgba(255, 255, 255, 0.6);
              font-size: 0.8rem;
            "
          >
            共 110 条
          </p>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            :page-size="100"
            layout="prev, pager, next, jumper"
            :total="1000"
            style="float: right"
          >
          </el-pagination> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { tunnelProgress, getTunnelStepData } from "@/public/api.js";
import {
  surroundingRoc,
  formatMileage,
  surroundingRockValues,
  surroundingRockValuesy,
  getLocalStorageWithExpiry,
  lastSevenDayData,
} from "@/utils/index.js";
import { tunnelStepData,tunnelssData } from "./SafeStepData.js";
import * as echarts from "echarts";

// 引入路由实例
export default {
  name: "SafeStep",
  components: {},
  data() {
    return {
      astSevenDays: lastSevenDayData(), // 新增最近七天的日期数组
      myChart1: null,
      myChart2: null,
      myChart3: null,
      currentPage: 1,
      StepDataData: [],
      TunnelsData: [],
      fromData: {
        pileNoMark: "",
        startingMileage: "",
        excavationTotalCompleted: 0,
        excavationQuantity: 0,
        liningTotalCompleted: 0,
        liningQuantity: 0,
        invertTotalCompleted: 0,
        invertQuantity: 0,
      },
      srcPath: "http://39.100.79.198:9991/index",
    };
  },
  computed: {},
  mounted() {
    // 初始化图表
    this.myChart1 = echarts.init(document.getElementById("main_Personnel1"));
    this.initChart(this.myChart1, [23, 77], "#FFB642");

    this.myChart2 = echarts.init(document.getElementById("main_Personnel2"));
    this.initChart(this.myChart2, [43, 57], "#69D4AA");

    this.myChart3 = echarts.init(document.getElementById("main_Personnel3"));
    this.initChart(this.myChart3, [23, 77], "#EE605E");

    // 监听窗口大小变化，自动调整图表
    window.addEventListener("resize", this.handleResize);

    this.TunnelsData = JSON.parse(localStorage.getItem("updateLhTunnels"));
    let hostName = window.location.hostname;
    if (
      hostName == "localhost" ||
      hostName == "127.0.0.1" ||
      hostName == "39.100.79.198" ||
      hostName == "sd.yongsixinxi.com"
    ) {
      hostName = "https://" + "3d.yongsixinxi.com";
    } else {
      hostName = "http://" + hostName + ":9990";
    }
    this.srcPath =
      hostName +
      "/tunnelModel?token=" +
      getLocalStorageWithExpiry("updateToken") +
      "&updateTunnelItemId=" +
      this.TunnelsData.itemId;

    this.getlist();
    this.getTunnelProgress();
  },
  methods: {
    formatMileage,
    surroundingRoc,
    surroundingRockValues,
    surroundingRockValuesy,
    getlist() {
      let that = this;
      getTunnelStepData({
        itemId: this.TunnelsData.itemId,
        startTime: this.astSevenDays[0].startTime + " 00:00:00",
        endTime: this.astSevenDays[0].startTime + " 23:59:59",
      }).then((res) => {
        if (res.data.code == 200) {
          let dataListDom = res.data.data;

          if (
            window.location.hostname == "127.0.0.1" ||
            window.location.hostname == "39.100.79.198" ||
            window.location.hostname == "sd.yongsixinxi.com"
          ) {
            dataListDom = tunnelStepData();
          }

          dataListDom.forEach((item) => {
            if (item.stepCode === "1") {
              item.stepCode = "二衬与开挖";
            } else if (item.stepCode === "2") {
              item.stepCode = "防水与开挖";
            } else if (item.stepCode === "3") {
              item.stepCode = "仰拱与开挖";
            } else if (item.stepCode === "4") {
              item.stepCode = "二衬与防水";
            } else if (item.stepCode === "5") {
              item.stepCode = "二衬与仰拱";
            } else if (item.stepCode === "6") {
              item.stepCode = "防水与仰拱";
            }
          });
          this.StepDataData = dataListDom;
        }
      });
    },
    getTunnelProgress() {
      let that = this;
      tunnelProgress({
        itemId: this.TunnelsData.itemId,
      }).then((res) => {
        if (res.data.code == 200) {
          let dataDom = res.data.data[0];

          if (
            window.location.hostname == "127.0.0.1" ||
            window.location.hostname == "39.100.79.198" ||
            window.location.hostname == "sd.yongsixinxi.com"
          ) {
            dataDom = tunnelssData()[0];
          }
          this.fromData.excavationTotalCompleted = dataDom.excavation.totalCompleted;
          this.fromData.excavationQuantity = dataDom.excavation.quantity;
          this.fromData.liningTotalCompleted = dataDom.lining.totalCompleted;
          this.fromData.liningQuantity = dataDom.lining.quantity;
          this.fromData.invertTotalCompleted = dataDom.invert.totalCompleted;
          this.fromData.invertQuantity = dataDom.invert.quantity;
          this.fromData.pileNoMark = dataDom.pileNoMark;
          this.fromData.startingMileage = dataDom.startingMileage;

          // this.liquidfill("main_dayAttendance", [
          //   (
          //     (this.fromData.excavationTotalCompleted /
          //       this.fromData.excavationQuantity) *
          //     100
          //   ).toFixed(1),
          // ]);
          // this.liquidfill("main_dayAttendances", [
          //   (
          //     (this.fromData.liningTotalCompleted /
          //       this.fromData.liningQuantity) *
          //     100
          //   ).toFixed(1),
          // ]);
          // this.liquidfill("main_dayAttendancel", [
          //   (
          //     (this.fromData.invertTotalCompleted /
          //       this.fromData.invertQuantity) *
          //     100
          //   ).toFixed(1),
          // ]);
        }
      });
    },
    initChart(myChart, data, color) {
      const option = {
        legend: {
          right: "30%",
          top: "center",
          orient: "vertical",
          data: [],
          textStyle: {
            color: "#333",
            fontSize: 12, // 缩小字体避免占用过多空间
          },
          itemWidth: 8, // 缩小图例标记
          itemHeight: 8,
          itemGap: 8, // 减小图例项间距
        },
        toolbox: {
          show: false,
        },
        series: [
          {
            type: "pie",
            center: ["40%", "40%"], // 调整位置避免超出
            radius: ["50%", "80%"], // 使用百分比半径，自适应容器
            itemStyle: {
              normal: {
                label: {
                  show: false,
                },
              },
            },
            data: [
              {
                name: "other",
                value: data[0],
                itemStyle: {
                  normal: {
                    color: color,
                    label: {
                      show: true,
                      position: "center",
                      textStyle: {
                        color: "#999",
                        fontSize: 12, // 缩小文字
                      },
                    },
                    labelLine: {
                      show: false,
                    },
                  },
                  emphasis: {
                    color: "rgba(0,0,0,0)",
                  },
                },
              },
              {
                name: "GoogleMaps",
                value: data[1],
                itemStyle: {
                  normal: {
                    color: "#333",
                    label: {
                      show: true,
                      position: "center",
                      formatter: "{b}",
                      textStyle: {
                        baseline: "bottom",
                        fontSize: 12,
                        color: "#333",
                      },
                    },
                    labelLine: {
                      show: false,
                    },
                  },
                },
              },
            ],
          },
        ],
      };

      myChart.setOption(option);
    },
    // 窗口大小变化时调整图表
    handleResize() {
      if (this.myChart1) {
        this.myChart1.resize();
      }
      if (this.myChart2) {
        this.myChart2.resize();
      }
      if (this.myChart3) {
        this.myChart3.resize();
      }
      if (this.myChart4) {
        this.myChart4.resize();
      }
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
  beforeDestroy() {
    // 移除事件监听，销毁图表
    window.removeEventListener("resize", this.handleResize);
    if (this.myChart1) {
      this.myChart1.dispose();
    }
    if (this.myChart2) {
      this.myChart2.dispose();
    }
    if (this.myChart3) {
      this.myChart3.dispose();
    }
  },
};
</script>
<style scoped>
/* 引入字体 */
@font-face {
  font-family: "DS-Digital";
  src: url("../font/DS-DIGIB.TTF") format("truetype");
  font-weight: normal;
  font-style: normal;
}

.cloud-SafeStep {
  position: relative;
  top: 5px;
  left: 1%;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  box-sizing: border-box;

  .cloud-SafeStep-l {
    width: 23%;
    height: 100%;
    float: left;
  }

  .cloud-SafeStep-r {
    width: 74%;
    height: 100%;
    float: left;
    margin-left: 1%;
  }

  .cloud-SafeStep-title {
    position: relative;
    margin-top: 1vh;
    left: 0;
    width: 100%;
    height: calc(445 / 1080 * 100vh);
    background: rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    overflow: hidden;
    /* 新增：禁止子元素超出父容器 */
    box-sizing: border-box;
    /* 新增：确保padding不撑大容器 */

    > .cloud-SafeStep-title-title {
      position: relative;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 2.5vh;
      margin: 0;
      padding: 0;

      img {
        width: 100%;
        height: auto;
        margin: 0;
        padding: 0;
        overflow: hidden;
        /* 新增：禁止子元素超出父容器 */
        box-sizing: border-box;
        /* 新增：确保padding不撑大容器 */
      }

      p {
        position: absolute;
        top: 0.3vh;
        left: 3.01vh;
        width: 100%;
        height: 3vh;
        line-height: 3vh;
        margin: 0;
        padding: 0;
        font-size: 1rem;
        color: #fff;
        text-align: left;
        white-space: nowrap;
        /* 关键：禁止文本换行 */
        text-overflow: ellipsis;
        /* 关键：超出部分显示省略号 */
        overflow: hidden;
        /* 关键：配合text-overflow生效 */
        max-width: calc(100% - 4vh);
        /* 新增：限制文本最大宽度，避免超出父容器 */
      }
    }

    .cloud-SafeStep-title-content {
      position: relative;
      top: 0px;
      left: 0px;
      width: 93%;
      height: calc(385 / 1080 * 100vh);
      margin: 0;
      padding: 10px;
      overflow-y: auto;
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
      overflow-y: auto;
      /* 保留纵向滚动，禁止横向滚动 */
      overflow-x: hidden;
      /* 关键：禁止横向内容跳出 */
      scrollbar-width: thin;
      scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
      box-sizing: border-box;
      /* 确保padding不撑大宽度 */
    }
  }

  ::v-deep .el-progress__text {
    font-size: 0.8rem !important;
    margin-left: 20px !important;
    color: #fff;
  }

  /* 图表容器样式 */
  .chart-container {
    width: 110%;
    height: 110%;
    /* 设置最小高度，避免过小 */
    box-sizing: border-box;
    padding: 0px;
    /* 增加内边距，避免内容贴边 */
  }

  .cloud-SafeStep-title-content-ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 2vh;

    > li {
      width: 90%;
      height: 7.5vh;
      margin: 0;
      padding: 0;
      float: left;
      margin-left: 6%;
      margin-top: 2vh;

      > div:nth-child(1) {
        width: 21%;
        height: 7.5vh;
        float: left;
        margin-right: 1%;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;
      }

      > div:nth-child(2) {
        width: 36%;
        height: 7.5vh;
        float: left;
        margin-right: 1%;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;
        text-align: left;

        > p:nth-child(1) {
          height: 3vh;
          line-height: 3vh;
          margin: 0;
          padding: 0;
          font-size: 1.5rem;
        }

        > p:nth-child(2) {
          height: 3vh;
          line-height: 3vh;
          margin: 0;
          padding: 0;
          font-size: 0.8rem;
        }
      }

      > div:nth-child(3) {
        width: 36%;
        height: 7.5vh;
        float: left;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;

        > p {
          width: 100%;
          height: 3vh;
          line-height: 3vh;
          margin: 0;
          padding: 0;
          font-size: 0.8rem;
          color: rgba(255, 255, 255, 0.6);
        }
      }
    }
  }

  .cloud-SafeStep-title-content-tables {
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;
    margin-top: 1vh;

    > p {
      height: 2.5vh;
      margin: 0;
      padding: 0;
      float: left;
      line-height: 2.5vh;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    > p:nth-child(1) {
      width: 20%;
    }

    > p:nth-child(2) {
      width: 20%;
    }

    > p:nth-child(3) {
      width: 20%;
    }

    > p:nth-child(4) {
      width: 15%;
    }

    > p:nth-child(5) {
      width: 20%;
    }
  }

  .cloud-SafeStep-title-content-table {
    width: 100%;
    height: 2.5vh;
    margin: 0;
    padding: 0;
    margin-top: 1vh;

    > p {
      height: 2.5vh;
      margin: 0;
      padding: 0;
      float: left;
      line-height: 2.5vh;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 0.8rem;
      color: rgba(255, 255, 255, 0.6);
      text-align: center;
      font-style: normal;
      text-transform: none;
    }

    > p:nth-child(1) {
      width: 5%;
    }

    > p:nth-child(2) {
      width: 11%;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    > p:nth-child(3) {
      width: 6%;
    }

    > p:nth-child(4) {
      width: 9%;
    }

    > p:nth-child(5) {
      width: 8%;
    }

    > p:nth-child(6) {
      width: 8%;
    }

    > p:nth-child(7) {
      width: 8%;
    }

    > p:nth-child(8) {
      width: 8%;
    }

    > p:nth-child(9) {
      width: 8%;
    }

    > p:nth-child(10) {
      width: 8%;
    }

    > p:nth-child(11) {
      width: 8%;
    }

    > p:nth-child(12) {
      width: 8%;
    }

    > p:nth-child(13) {
      width: 5%;
    }
  }

  ::v-deep .el-pagination .el-pager li {
    background-color: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #409eff !important;
    border-radius: 4px !important;
    margin: 0.2vw;
  }

  ::v-deep .el-pagination .btn-prev {
    background-color: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #409eff !important;
    height: 25px !important;
    margin-top: 5px;
  }

  ::v-deep .el-pagination .btn-next {
    background-color: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.12);
    color: #409eff !important;
    height: 25px !important;
    margin-top: 5px;
  }

  ::v-deep .el-pagination .el-pager li.active {
    background-color: #409eff !important;
    color: #fff !important;
  }

  ::v-deep .el-pagination__jump {
    font-size: 0.6rem !important;
    height: 20px !important;
    line-height: 20px !important;
  }

  ::v-deep .el-pagination .el-input__inner {
    background-color: transparent !important;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }

  /* 选中状态样式 */
  .cloud-SafeStep-title-title-ul-day li.active .dayDiv {
    background-color: #409eff;
    /* 示例蓝色，可替换为需要的颜色 */
    color: #fff;
    /* 选中时文字变白，提高对比度 */
    border-radius: 4px;
  }
}
</style>